import { getCookie } from './CookieHelper.js';

// Single source of truth for reading the cookie-banner consent decision, so
// services and components don't each re-implement it.
// cookie_prefs = { date, consent: 'all' | 'required' } (set by cookie-banner.vue).

const CONSENT_COOKIE = 'cookie_prefs';

export function hasStatisticsConsent() {
  try {
    return JSON.parse(getCookie(CONSENT_COOKIE))?.consent === 'all';
  } catch (_) {
    return false;
  }
}

export function consentDecisionMade() {
  return getCookie(CONSENT_COOKIE) != null;
}
